// extracted by mini-css-extract-plugin
export default {"pointsContainer":"pointsScreen_pointsContainer__GbLDf","myPoints":"pointsScreen_myPoints__vQIkC"};